// Side snap for "Object Snap Setting" (Left/Right/Top/Bottom Side).
// The option names the side of the moving booth `a` that snaps flush to the
// facing side of booth `b`. Only the perpendicular axis is set, so the booth
// can still slide along the edge; recomputed on every move, so dragging past
// `edge` releases it. Requires the spans to overlap (booths "line up").
// No fabric import on purpose, so this stays unit-testable on its own.
// ponytail: bounding box, unrotated/unscaled - same limits as the corner snaps.
export const SIDE_SNAP_OPTIONS = ['Left Side', 'Right Side', 'Top Side', 'Bottom Side']

export const getSideSnap = (align, a, b, edge) => {
    // strict < / > so booths that only touch at a corner don't count as lined up
    const overlapY = a.top < b.top + b.height && a.top + a.height > b.top
    const overlapX = a.left < b.left + b.width && a.left + a.width > b.left
    if (align == 'Left Side' && overlapY && Math.abs(a.left - (b.left + b.width)) < edge) return { left: b.left + b.width }
    if (align == 'Right Side' && overlapY && Math.abs(a.left + a.width - b.left) < edge) return { left: b.left - a.width }
    if (align == 'Top Side' && overlapX && Math.abs(a.top - (b.top + b.height)) < edge) return { top: b.top + b.height }
    if (align == 'Bottom Side' && overlapX && Math.abs(a.top + a.height - b.top) < edge) return { top: b.top - a.height }
    return null
}
